import { PropsWithChildren } from 'react';

import { useSceneMenuContext } from './context';

export function SceneMenuContent({ children }: PropsWithChildren) {
  return useSceneMenuContext().activeReplacement ? null : children;
}
